import {createApp} from 'vue'
import router from './router'
import store from './store'
import App from './App.vue'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import locale from 'element-plus/es/locale/lang/zh-cn'
import lazyUseComponent from './core/lazyUse'
import hasPermi from './core/hasPerm'
import modal from './core/modal'
import 'element-plus/dist/index.css'
import './assets/css/style.css'
import './router/permission'
import {erasureHtml, formatNumber, formatThousandsAmt, formatTimestampToDate, getTimePickerOptions, getDatePickerOptions, exportBlod} from '@/utils'


const app = createApp(App)

app.config.globalProperties.$modal = modal
app.config.globalProperties.$erasureHtml = erasureHtml
app.config.globalProperties.$store = store
app.config.globalProperties.$formatNumber = formatNumber
app.config.globalProperties.$formatThousandsAmt = formatThousandsAmt
app.config.globalProperties.$formatTimestampToDate = formatTimestampToDate
app.config.globalProperties.$getTimePickerOptions = getTimePickerOptions
app.config.globalProperties.$getDatePickerOptions = getDatePickerOptions
app.config.globalProperties.$download = exportBlod

app.use(lazyUseComponent, app)
app.use(hasPermi)
app.use(router).use(store)
app.use(ElementPlus, {locale})
app.mount('#app')
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
